import TestWebComponent from './Test';
import ButtonComponent from './Button';
import AppFeatureComponent from './AppFeature';
import { CarouselV2Component } from './CarouselV2';
import FavoriteIconComponent from './FavoriteIcon';
import SectionHeaderComponent from './SectionHeader';
import VenueCarouselComponent from './VenueCarousel';
import PromotionalComponent from './PromotionalComponent';
import PromotionalHeroBannerComponent from './PromotionalHeroBanner';
import { VenueCardComponent, FavoriteVenueCardComponent } from './Cards';
import AppDownloadBannerComponent from './AppDownloadBanner';
import EmailConsentBoxComponent from './EmailConsentBox';
import { BasicModal, TooManyFavouriteModal, SignupMpdal } from './Modal';

const customComponents = [
	TestWebComponent,
	CarouselV2Component,
	FavoriteIconComponent,
	PromotionalHeroBannerComponent,
	SectionHeaderComponent,
	VenueCarouselComponent,
	AppFeatureComponent,
	PromotionalComponent,
	VenueCardComponent,
	FavoriteVenueCardComponent,
	ButtonComponent,
	AppDownloadBannerComponent,
	BasicModal,
	TooManyFavouriteModal,
	SignupMpdal,
	EmailConsentBoxComponent
];

customComponents.forEach((component) => {
	if (component.key) {
		customElements.define(component.key, component);
	} else {
		console.error(`Component ${component.name} is missing a key`);
	}
});

export default customComponents;
